<div class="dates">
  <div class="dates__with-dates" *ngIf="startDate(); else emptyMessage">
    {{ startDate() | lxStudyPeriod : endDate() }}
  </div>
</div>

<ng-template #emptyMessage>
  <div class="dates__empty-dates">
    {{ emptyMsg() }}
  </div>
</ng-template>
